import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { removeDefaultHandler } from './remove-default-handler.fn';

// Removes the existing noty that would show up
// and passes the error on to downstream operators/subscribers
export function noDefaultErrorHandler<T>(): (
  source: Observable<T>,
) => Observable<T> {
  return (source: Observable<T>): Observable<T> => {
    return source.pipe(
      catchError((err) => {
        removeDefaultHandler(err);
        return throwError(err);
      }),
    );
  };
}
